import { PagedData, PagingData, RequestOptions, AnyObject } from '@/types'
import { Http } from './http'

// 该paging的使用时，可以通过 new Paging({url: , data}, recordCount) 将 paging 按照特定 get api 地址进行配置。然后即可使用该类的方法 getMoreData()来获取数据。
// static getTransactionRecordsPaging (data = {}) {
//   return new Paging(
//     {
//       url: 'finance/user-transaction-records', // 请求的地址
//       data // 请求的数据
//     },
//     19 // 默认的数据条数
//   )
// }
class Paging<ReturnRecordType> extends Http {
  // 实例化 new Paging

  // public field declarations
  start: number
  count: number
  req: { url: string; data?: AnyObject; method?: RequestOptions }
  locker = false
  url: string
  data = {}
  moreData = true
  accumulator: ReturnRecordType[] = []

  constructor (
    req: { url: string; data?: AnyObject; method?: RequestOptions },
    count = 10,
    start = 0
  ) {
    super() // super must be called before using "this" in inheritated class.
    this.start = start
    this.count = count
    this.req = req
    this.url = req.url
  }

  // 获取更多数据
  async getMoreData (): Promise<null | PagingData<ReturnRecordType>> {
    // step1: getLocker
    if (!this.moreData) {
      // 如果没有更多的数据了，则不需要再去请求，直接返回
      return null
    }
    if (!this._getLocker()) {
      // 得到数据锁状态，如果没有上锁则加锁。如果数据锁已锁死，则说明请求正在进行中，需要等待结果，不需要再去请求，直接返回
      return null
    }
    // step2: request
    const data = await this._actualGetData()
    // step3: releaseLocker
    this._releaseLocker()
    return data
  }

  // 实际获得数据
  async _actualGetData (): Promise<null | PagingData<ReturnRecordType>> {
    // step 1: 在传入的url上加入 offset 与 limit
    const req = this._getCurrentReq()
    // step 2: 通过HTTP类进行数据请求
    console.log(`paging _actualGetData data: ${this.data}`)
    console.log(this.data)
    const res = await this.axios().get<PagedData<ReturnRecordType>>(req.url, {
      params: { ...this.req.data }
    }) // 进行HTTP请求
    const paging = res.data
    // step 3: 分析数据并对paging类中的变量进行修改
    if (!paging) {
      // 如果没有返回值，则返回 null
      return null
    }
    if (paging.totalRecrodNumber === 0) {
      // 如果有返回但为空，则返回 null
      return {
        empty: true,
        // 当前请求的数据
        items: [],
        moreData: false,
        // 请求的数据累加
        accumulator: []
      }
    }

    this.moreData = Paging._moreData(
      paging.totalPageNumber,
      paging.currentPageNumber
    )
    if (this.moreData) {
      this.start += this.count
    }
    this._accumulate(paging.items)
    return {
      empty: false,
      items: paging.items,
      moreData: this.moreData,
      accumulator: this.accumulator
    }
  }

  _accumulate (items: ReturnRecordType[]): void {
    this.accumulator = this.accumulator.concat(items)
  }

  static _moreData (totalPage: number, pageNum: number): boolean {
    return pageNum < totalPage - 1
  }

  // 自定义获取url函数
  _getCurrentReq (): { url: string; data?: AnyObject; method?: RequestOptions } {
    // 在已有url基础上增加 offset 和 limit
    let url = this.url
    const params = `offset=${this.start}&limit=${this.count}&paging=true`
    if (url.includes('?')) {
      url += '&' + params
      // contains
    } else {
      url += '?' + params
    }
    this.req.url = url
    return this.req
  }

  _getLocker (): boolean {
    // 得到数据锁状态，如果没有上锁则加锁。
    if (this.locker) {
      return false
    }
    this.locker = true
    return true
  }

  _releaseLocker (): void {
    this.locker = false
  }
}

export { Paging }
